import React from "react";
import SvgIconBase from "./SvgIconBase";
import { SvgIconProps } from "@mui/material/SvgIcon";

export const SaveIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIconBase {...props}>
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 5.75C3.5 5.02065 3.78973 4.32118 4.30546 3.80546C4.82118 3.28973 5.52065 3 6.25 3H16.215C17.0769 3.00005 17.9035 3.34249 18.513 3.952L20.548 5.987C21.158 6.597 21.5 7.424 21.5 8.286V18.25C21.5 18.9793 21.2103 19.6788 20.6945 20.1945C20.1788 20.7103 19.4793 21 18.75 21H6.25C5.52065 21 4.82118 20.7103 4.30546 20.1945C3.78973 19.6788 3.5 18.9793 3.5 18.25V5.75ZM6.25 4.5C5.56 4.5 5 5.06 5 5.75V18.25C5 18.94 5.56 19.5 6.25 19.5H6.5V14.25C6.5 13.6533 6.73705 13.081 7.15901 12.659C7.58097 12.2371 8.15326 12 8.75 12H16.25C16.8467 12 17.419 12.2371 17.841 12.659C18.2629 13.081 18.5 13.6533 18.5 14.25V19.5H18.75C19.44 19.5 20 18.94 20 18.25V8.286C20 7.821 19.816 7.376 19.487 7.048L17.452 5.013C17.1937 4.75422 16.8607 4.58286 16.5 4.523V7.25C16.5 7.54547 16.4418 7.83805 16.3287 8.11104C16.2157 8.38402 16.0499 8.63206 15.841 8.84099C15.6321 9.04992 15.384 9.21566 15.111 9.32873C14.8381 9.4418 14.5455 9.5 14.25 9.5H9.75C9.15326 9.5 8.58097 9.26295 8.15901 8.84099C7.73705 8.41903 7.5 7.84674 7.5 7.25V4.5H6.25ZM17 19.5V14.25C17 14.0511 16.921 13.8603 16.7803 13.7197C16.6397 13.579 16.4489 13.5 16.25 13.5H8.75C8.55109 13.5 8.36032 13.579 8.21967 13.7197C8.07902 13.8603 8 14.0511 8 14.25V19.5H17ZM9 4.5V7.25C9 7.664 9.336 8 9.75 8H14.25C14.4489 8 14.6397 7.92098 14.7803 7.78033C14.921 7.63968 15 7.44891 15 7.25V4.5H9Z"
        fill="#F0F1FA"
      />
    </svg>
  </SvgIconBase>
);
